export default "__VITE_ASSET__DpRwO4Se__"